import React, { useEffect } from 'react';
import { OverlaySpinner } from '@insurancemenu/imenu-components-lib';
import { observer } from 'mobx-react-lite';
import ICensusUploadPageStore, { CensusUploadDomainParams } from 'store/modules/census/iCensusUploadPageStore';
import { ICensusModule } from 'store/modules/census/iCensusModule';
import ExistingInvalidCensusSection from '../ExistingInvalidCensusSection';
import CensusUpload from '../CensusUpload';
import ExistingValidCensusSection from '../ExistingValidCensusSection';
import CensusTemplateSection from '../CensusTemplateSection';
import { ContentWrapperStyled } from './styles';
import { PAGE_LOADER_TEST_ID } from '../constants';

interface Props {
  pageStore: ICensusUploadPageStore<CensusUploadDomainParams, ICensusModule<CensusUploadDomainParams>>;
}

export const BasicCensusFlowLayout: React.FC<Props> = observer(({ pageStore }) => {
  useEffect(() => {
    void pageStore.getCensusData();
  }, []);

  const existingCensusInfo = pageStore.censusModule.existingCensusInfo;

  return (
    <ContentWrapperStyled>
      <CensusTemplateSection downloadCensusTemplate={pageStore.censusModule.downloadCensusTemplate} />
      {existingCensusInfo?.exist && existingCensusInfo.valid && <ExistingValidCensusSection pageStore={pageStore} />}
      {existingCensusInfo?.exist && !existingCensusInfo.valid && <ExistingInvalidCensusSection pageStore={pageStore} />}
      <CensusUpload pageStore={pageStore} />
      <OverlaySpinner display={pageStore.isLoading} data-test-id={PAGE_LOADER_TEST_ID} />
    </ContentWrapperStyled>
  );
});
